/** The longest side a profile photo is sent at: the server makes it a 256px square, so more is wasted upload. */
export const SENT_SIZE = 1024;
const QUALITY = 0.9;

/** How big to draw a photo so its longest side is at most `max`, keeping its shape. */
export function fitWithin(width, height, max = SENT_SIZE) {
  const scale = Math.min(1, max / Math.max(width, height));
  return { width: Math.round(width * scale), height: Math.round(height * scale) };
}

/**
 * A phone photo made small enough to send, as a JPEG: an iPhone's is several megabytes (and may be HEIC), more than
 * servers take. The browser decodes it, turned the way it was taken.
 *
 * @param {File} file the photo chosen
 * @returns {Promise<Blob>}
 */
export async function shrinkPhoto(file) {
  const image = await createImageBitmap(file, { imageOrientation: 'from-image' });
  const { width, height } = fitWithin(image.width, image.height);
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  canvas.getContext('2d').drawImage(image, 0, 0, width, height);
  image.close();
  return new Promise((resolve, reject) => canvas.toBlob(
    blob => (blob ? resolve(blob) : reject(new Error("That picture couldn't be read."))),
    'image/jpeg',
    QUALITY,
  ));
}
